import { AppState } from "../../store";
//Selectors that pull values from state.
export const getCurrentTabValue = (state: AppState) => state.reducer.Tabs;